import { useT } from '@hooks';
import React from 'react';
import TimerV3 from '../timerV3';
import checkTheme from '../../../../../src/utils/custom/checkTheme';

import s from './index.module.scss';

function DiscountBlockV3() {
	const { T } = useT();

	return (
		<div className={`${s.discountBlockV3} ${s[checkTheme()]}`}>
			<div className={s.discountBlockV3_block}>
				<div className={s.discountBlockV3_block1}>
					<p className={s.discountBlockV3_block1Title}>{T('discount_block_2')}</p>
					<div className={s.discountBlockV3_block1Card}>
						<p className={s.discountBlockV3_block1Text1}>Newcomer_oct23</p>
						<p className={s.discountBlockV3_block1Text2}>lastcall_oct123</p>
						<div className={s.discountBlockV3_block1LabelWrapper}>
							<div className={s.discountBlockV3_block1Label}></div>
						</div>
					</div>
				</div>
				<div className={s.discountBlockV3_block2}>
					<p className={s.discountBlockV3_block2Title}>{T('discount_block_3')}</p>
					<div className={s.discountBlockV3_block2Card}>
						<TimerV3 />
					</div>
				</div>
			</div>
		</div>
	);
}

export default DiscountBlockV3;
